import * as React from 'react';
export const IcPlaylistSuccessful = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.61 6.92c.124.05.256.077.39.08h16a1 1 0 00.92-1.39 1.058 1.058 0 00-.21-.31A1.059 1.059 0 0020 5H4a1.09 1.09 0 00-.39.08 1.06 1.06 0 00-.31.21 1.06 1.06 0 00-.21.31 1 1 0 000 .78 1 1 0 00.52.54zm6.78 10.16A1.089 1.089 0 0010 17H4a1 1 0 00-.39 1.92c.124.05.256.078.39.08h6a1 1 0 00.39-1.92zm.32-5.79A1 1 0 0010 11H4a1 1 0 00-1 1 1.19 1.19 0 000 .26.53.53 0 000 .12A1 1 0 004 13h6a1 1 0 00.92-.62.523.523 0 000-.12c.037-.083.063-.17.08-.26a.998.998 0 00-.29-.71zm8.58 1.5l-3.79 3.8-1.79-1.8a1.005 1.005 0 00-1.42 1.42l2.5 2.5a1.001 1.001 0 001.42 0l4.5-4.5a1.003 1.003 0 00-1.094-1.638c-.122.05-.233.125-.326.218z'
      fill='currentColor'
    />
  </svg>
);
